import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl'

import withToast from 'src/components/Toast'
import intlMessages from '../../translations'
import Disclaimer from 'src/modals/Disclaimer'
import intlMessagesApp from 'src/modules/App/translations'
import Button from 'src/components/Button/Button'
import { Layout, Container, PageTitle } from 'src/components/Layout'

class RemoveConfirmation extends PureComponent {
  state = {
    showDisclaimer: false,
  }

  componentDidMount() {
    const { vehicle, history } = this.props

    if (!vehicle) {
      history.push('/changepolicy/vehicle/remove')
    }
  }

  componentDidUpdate(prevProps) {
    const { intl, submitting, history, successful, toast } = this.props

    if (!submitting && prevProps.submitting && successful) {
      history.push('/changepolicy')
      toast({
        title: intl.formatMessage(intlMessages.changePolicyVehicleThankYouTitle),
        description: intl.formatMessage(intlMessages.changePolicyNotificationSuccess),
        status: 'success',
      })
    }

    if (!submitting && prevProps.submitting && !successful) {
      toast({
        message: intl.formatMessage(intlMessagesApp.appErrorTitle),
        description: intl.formatMessage(intlMessages.changePolicyNotificationError),
        status: 'error',
      })
    }
  }

  handleConfirmation = () => {
    this.setState({
      showDisclaimer: true,
    })
  }

  handleCloseDisclaimer = () => {
    this.setState({
      showDisclaimer: false,
    })
  }

  handleSubmitDisclaimer = () => {
    const { vehicle, document, removeDocumentVehicle } = this.props

    removeDocumentVehicle(vehicle.id, document.id, document.category || 'other')
  }

  renderThankYou = vehicle => {
    let { countryIsoCode } = this.props

    return (
      <React.Fragment>
        <h2>
          <FormattedMessage id='app.document.removeVehicle.thankYou' defaultMessage='Thank you' />
        </h2>
        <p>
          {countryIsoCode && countryIsoCode === 'us' ? (
            <FormattedHTMLMessage
              id='app.document.removeVehicle.thankYouBodyUS'
              defaultMessage='Your request to remove <br /> {year} {make} {model} has been sent to your agent'
              values={{
                year: vehicle.year,
                make: vehicle.make,
                model: vehicle.model,
              }}
            />
          ) : (
            <FormattedHTMLMessage
              id='app.document.removeVehicle.thankYouBody'
              defaultMessage='Your request to remove <br /> {year} {make} {model} has been sent to your broker'
              values={{
                year: vehicle.year,
                make: vehicle.make,
                model: vehicle.model,
              }}
            />
          )}
        </p>
      </React.Fragment>
    )
  }

  renderConfirmation = vehicle => {
    return (
      <React.Fragment>
        <h2>
          <FormattedMessage
            id='app.document.removeVehicle.confirm'
            defaultMessage='Please confirm'
          />
        </h2>
        <p>
          <FormattedHTMLMessage
            id='app.document.removeVehicle.confirmBody'
            defaultMessage='Are you sure you want to remove <br /> {year} {make} {model}'
            values={{
              year: vehicle.year,
              make: vehicle.make,
              model: vehicle.model,
            }}
          />
        </p>

        <Button mt={`20px`} isFullWidth size='lg' type='submit' onClick={this.handleConfirmation}>
          <FormattedMessage id='app.document.removeVehicle.submit' defaultMessage='Submit' />
        </Button>
      </React.Fragment>
    )
  }

  render() {
    const { vehicle, intl, submitting } = this.props
    const { showDisclaimer } = this.state

    return (
      <Layout>
        <PageTitle title={intl.formatMessage(intlMessages.documentRemoveDriverHeadline)} showBack />
        <Container padder className='global-centered-desktop-content'>
          <div style={{ textAlign: 'center' }}>{this.renderConfirmation(vehicle)}</div>
          <Disclaimer
            visible={showDisclaimer}
            loading={submitting}
            skipAfterHoursCheck={true}
            onClose={this.handleCloseDisclaimer}
            onSubmit={this.handleSubmitDisclaimer}
          />
        </Container>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(withToast(RemoveConfirmation)))
